import BtnLink from "../campusLife/BtnLink"
import { PropTypes } from 'prop-types';


const Privacy = ({ title, content, personalDataAccessForm, personalDataCorrectionForm }) => {
    return (
        <div className="flex flex-col gap-5 w-full  p-4 max-h-[80vh] max-w-[80vw]  ">
            <h1 className=" text-zinc-950 text-xl sm:text-3xl font-bold">{title}</h1>
            <p className="text-sky-950 text-opacity-70 text-lg font-normal overflow-y-auto scroll-bar">
                <div className="flex items-center justify-center">
                    <div className="w-full flex items-center flex-wrap max-w-2xl self-center justify-between  my-4">
                        <BtnLink text={"Personal Access Data Form"} file={personalDataAccessForm}/>
                        <BtnLink text={"Personal Data Correction Form"} file={personalDataCorrectionForm}/>
                    </div>
                </div>
                {content}
            </p>

        </div>
    )
}
Privacy.propTypes ={
    title : PropTypes.string,
    content : PropTypes.any,
    personalDataAccessForm : PropTypes.string,
    personalDataCorrectionForm : PropTypes.string,



}
export default Privacy